import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmLooseBarrelTypeForm from '../../../components/forms/FirearmLooseBarrelTypeForm';
import { useCreateFirearmLooseBarrelType } from '../../../hooks/useFirearmLooseBarrelTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmLooseBarrelTypeDTO } from '../../../services/apiClient';

const FirearmLooseBarrelTypeCreate: React.FC = () => {
  const createFirearmLooseBarrelType = useCreateFirearmLooseBarrelType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Loose Barrel Types', href: '/admin/firearmloosebarreltypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmLooseBarrelTypeDTO) => {
    try {
      await createFirearmLooseBarrelType.mutateAsync(data);
      navigate('/admin/firearmloosebarreltypes');
    } catch (error) {
      console.error('Error creating FirearmLooseBarrelType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmloosebarreltypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmLooseBarrelType.Edit'
    >
        <FirearmLooseBarrelTypeForm
          initialValues={{} as FirearmLooseBarrelTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmloosebarreltypes')}
        />
    </AdminLayout>
  );
};

export default FirearmLooseBarrelTypeCreate;